import { render, staticRenderFns } from "./impact-ela-growth.vue?vue&type=template&id=3cc0ac36"
import script from "./impact-ela-growth.ts?vue&type=script&lang=ts&external"
export * from "./impact-ela-growth.ts?vue&type=script&lang=ts&external"
import style0 from "./impact-ela-growth.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports